module.exports = __webpack_public_path__ + "static/Teko-c-min-64fc1bd78427d49b57d3fd235f51ba8c.png";